module.exports = __webpack_public_path__ + "img/jp.e2d838a2.svg";